<template>
  <v-card-title class="ds-dialog-header d-flex justify-space-between align-center">
    <div class="d-flex align-center" style="position: relative; z-index: 1;">
      <v-icon left color="white">{{ dialogIcon }}</v-icon>
      <span class="ds-dialog-title ml-2">
        {{ isEditMode ? `Atualizar ${userTypeLabel}: ${user.name}` : `Cadastrar ${userTypeLabel}` }}
      </span>
    </div>

    <div class="d-flex align-center" style="position: relative; z-index: 1;">
      <v-btn
        icon
        color="white"
        class="close-btn"
        aria-label="Ver tour deste cadastro"
        @click="$emit('help')"
      >
        <v-icon>mdi-help-circle-outline</v-icon>
      </v-btn>
      <v-btn icon color="white" class="close-btn" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
  </v-card-title>
</template>

<script>
export default {
  name: "AddNewUserDialogHeader",

  props: {
    dialogIcon: { type: String, required: true },
    isEditMode: { type: Boolean, default: false },
    userTypeLabel: { type: String, required: true },
    user: { type: Object, required: true },
  },
};
</script>

<style scoped>
.ds-dialog-title {
  font-size: 15px !important;
  font-weight: 700 !important;
  letter-spacing: 0.3px;
  color: var(--ds-white) !important;
}
.close-btn {
  position: relative;
  z-index: 1;
}
.close-btn:hover {
  background-color: rgba(255, 255, 255, 0.15) !important;
}
</style>
